// extracted by mini-css-extract-plugin
export default {"durationInfo":"components-workTime-TodaysWorkTimeInfoDetailEntry-__durationInfo"};